import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TableRecordTooltip from '../TableRecordTooltip';
import isTextColumn from '../../utils/isTextColumn';
import shouldHotjarMaskReportColumn from '../../utils/shouldHotjarMaskReportColumn';
import HotjarMasked from '../HotjarMasked';
import formatColumnValue from '../../utils/formatColumnValue';

const ReportDetailsTableColumn = ({ keyName, isTooltip, record }) => {
  if (isTooltip) {
    return (
      <td key={keyName}>
        {shouldHotjarMaskReportColumn(keyName) ? (
          <HotjarMasked isInline><TableRecordTooltip text={record[keyName]} /></HotjarMasked>
        ) : (
          <TableRecordTooltip text={record[keyName]} />
        )}
      </td>
    );
  }
  return (
    <td key={keyName}>
      <div
        className={classNames({
          'right-to-left-column': !isTextColumn(keyName)
        })}
      >
        {shouldHotjarMaskReportColumn(keyName) ? (
          <HotjarMasked isInline>{formatColumnValue(keyName, record)}</HotjarMasked>
        ) : (
          formatColumnValue(keyName, record)
        )}
      </div>
    </td>
  );
};

ReportDetailsTableColumn.propTypes = {
  keyName: PropTypes.string.isRequired,
  isTooltip: PropTypes.bool,
  record: PropTypes.object.isRequired
};

export default ReportDetailsTableColumn;
